/*
 * Component Long Description
 * 
 * @module product-long-description
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'product-long-description';

 if (!customElements.get(customElements.component)) {

    class productLongDescription extends HTMLElement {
 
        /**
         * Asembly Instructions web component.
         * 
         * @constructor
         */
        constructor() {

            super();

            this.metafields = window.theme.productMetafields;
        
            this.initEvents();
        }

        /**
         * Init module
         */
        initEvents()  {
            window.addEventListener('variant-change', this.onVariantChange.bind(this));
        }

        onVariantChange(event) {

            this.metafields.productMetafields.variantMetafields.forEach(variantMetafields => {

                if(variantMetafields.variant_id == event.detail.variantId) {

                    let html = this.renderProductLongDescription(variantMetafields);
                    // console.log(html)

                    if (html != '') {
                        this.innerHTML = `<div class="product-long-description__content">`  + html + `</div">`  ;
                    } else {
                        document.querySelector("[data-product-long-description]").classList.add("hidden");
                    }
            
                }
            });
            
        }

        renderProductLongDescription(variantMetafields) {
            let html = "";
            let variantDescription = variantMetafields?.variant_long_description || '';
            let productDescription = this.metafields.productMetafields?.variant_long_description || '';
            // console.log(html,variantDescription,productDescription)
            html += this.renderMetafields(variantDescription, productDescription, true);

            // html += this.renderMetafields(variantMetafields.variant_long_description, this.metafields.productMetafields.variant_long_description, true);
            return  html;
        }

        fixString(string) {
            string = string.replace(/^./, "");
            string = string.replace(/.$/, '');

            return string;
        }

        renderMetafields(variantValue, productValue, fix) {
            if (variantValue != '' && variantValue != 'null') {
                // if (fix) {
                //     variantValue = this.fixString(variantValue);
                // }
                return `<div class="product-long-description__field">`
                    + variantValue +
                `</div>`;
            // } else if (productValue != '' && productValue != 'null') {
            //     // if (fix) {
            //     //     productValue = this.fixString(productValue);
            //     // }
            //     return `<div class="product-long-description__field">`
            //         + productValue +
            //     `</div>`;
            } else {
                return '';
            }
        }

    }

    customElements.define(customElements.component, productLongDescription);
}


